module.exports = __webpack_public_path__ + "static/media/logoHD.dfb04723.png";